var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroups = function SvgGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 31.03,
    y1: 195.79,
    x2: 209.61,
    y2: 79.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 25.51,
    y1: 187.3,
    x2: 204.08,
    y2: 71.02,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -11.68,
    y1: 130.19,
    x2: 166.89,
    y2: 13.91,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -23.66,
    y1: 111.79,
    x2: 154.91,
    y2: -4.49,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M116.39,138.11c8.77-5.48,14.61-15.21,14.62-26.3h0c0-17.12-13.88-31.01-31.01-31.01s-31.01,13.88-31.01,31.01c0,11.1,5.84,20.83,14.6,26.31-16.49,6.53-28.15,22.62-28.15,41.44v16.26c0,2.16,1.75,3.91,3.91,3.91h81.3c2.16,0,3.91-1.75,3.91-3.91v-16.26c0-18.82-11.67-34.92-28.17-41.44ZM76.81,111.81c0-12.81,10.38-23.19,23.19-23.19,12.8.01,23.18,10.39,23.19,23.19,0,12.8-10.37,23.18-23.17,23.19,0,0-.01,0-.02,0s-.01,0-.02,0c-12.8-.01-23.17-10.39-23.17-23.19ZM136.74,191.91H63.26v-12.35c0-20.29,16.45-36.74,36.74-36.74,20.29,0,36.74,16.45,36.75,36.74v12.35Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,109.5c-5.22-9.27-13.27-15.95-22.45-19.57,8.78-5.48,14.62-15.21,14.64-26.31h0c0-17.12-13.88-31.01-31.01-31.01-17.12,0-31.01,13.88-31,31.01,0,11.1,5.84,20.83,14.61,26.31-1.86.74-3.7,1.61-5.49,2.62-1.86,1.06-2.52,3.43-1.47,5.3,1.05,1.88,3.43,2.55,5.32,1.5,5.5-3.1,11.71-4.73,18.02-4.73,20.3,0,36.76,16.44,36.77,36.74v12.35h-49.39c-2.16,0-3.91,1.75-3.91,3.91s1.75,3.91,3.91,3.91h53.29c2.16,0,3.91-1.75,3.91-3.91v-16.26c0-7.66-1.98-15.19-5.74-21.86ZM132.25,63.62c0-12.81,10.38-23.19,23.19-23.19,12.8.02,23.18,10.39,23.19,23.19h0c0,12.73-10.26,23.06-22.96,23.19-.14,0-.28,0-.41,0-12.73-.1-23.01-10.44-23.01-23.19Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1,147.63c0-2.16-1.75-3.91-3.91-3.91H7.81v-12.35c0-6.31,1.63-12.52,4.73-18.02,6.71-11.92,19.08-18.65,31.84-18.73.06,0,.12,0,.17,0,.04,0,.09,0,.13,0,6.08.01,12.24,1.54,17.91,4.73,1.88,1.06,4.26.4,5.32-1.48,1.06-1.88.4-4.26-1.48-5.32-1.78-1-3.62-1.88-5.51-2.62,8.77-5.48,14.62-15.21,14.63-26.31,0-17.12-13.88-31.01-31.01-31.01s-31.01,13.88-31.01,31.01c0,11.1,5.84,20.83,14.61,26.31C11.67,96.46,0,112.55,0,131.37v16.26c0,2.16,1.75,3.91,3.91,3.91h53.29c2.16,0,3.91-1.75,3.91-3.91ZM21.36,63.62c0-12.81,10.38-23.19,23.19-23.19,12.8.01,23.18,10.39,23.19,23.19,0,12.81-10.38,23.19-23.19,23.19s-23.19-10.38-23.19-23.19Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,62.29c17.12-.02,30.99-13.89,31.01-31.01,0-17.12-13.88-31.01-31.01-31.01s-31.01,13.88-31.01,31.01,13.88,31.01,31.01,31.01ZM100,8.09c12.8.01,23.18,10.39,23.19,23.19,0,12.81-10.38,23.19-23.19,23.19s-23.19-10.38-23.19-23.19,10.38-23.19,23.19-23.19Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }));
};
export default SvgGroups;